module.exports = __webpack_public_path__ + "static/img/20200629080919_23800.7324045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20200629080919_23800.png
// module id = +egv
// module chunks = 73